// import React, { useState } from 'react'
// import YoutubeIcon from '../../icons/YoutubeIcon'
// import FacebookIcon from '../../icons/FacebookIcon'
// import LinkedInIcon from '../../icons/LinkedInIcon'
// import userAdd from '../../../../assets/useradd.png'

// const MediaSwitcher: React.FC = () => {
//   const [open, setOpen] = useState(false)

//   return (
//     <div className="relative inline-block">
//       <span
//         onClick={() => setOpen((prev) => !prev)}
//         className="flex justify-center items-center rounded-full cursor-pointer"
//       >
//         <img src={userAdd} alt="addUser Logo" className="object-contain" />
//       </span>

//       <div
//         className={`absolute top-6 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-lg p-1 flex flex-col z-50 w-8 transition-all duration-200 ease-in-out
//                 ${open ? 'opacity-100 scale-100 visible' : 'opacity-0 scale-95 invisible'}`}
//       >
//         <a className="hover:text-blue-600">
//           <YoutubeIcon />
//         </a>
//         <a className="hover:text-sky-500">
//           <FacebookIcon />
//         </a>
//         <a className="hover:text-pink-500">
//           <LinkedInIcon />
//         </a>
//       </div>
//     </div>
//   )
// }

// export default MediaSwitcher
import React from 'react'
import YoutubeIcon from '../../icons/YoutubeIcon'
import FacebookIcon from '../../icons/FacebookIcon'
import LinkedInIcon from '../../icons/LinkedInIcon'

const MediaSwitcher: React.FC = () => {
  return (
    <div className="flex items-center gap-3">
      <a
        // href="https://youtube.com"
        href="https://www.youtube.com/@kiedkerala"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-red-600 transition-colors"
        // className="bg-white p-2 rounded-full shadow hover:text-red-600 transition-colors"
      >
        <YoutubeIcon />
      </a>
      <a
        // href="https://facebook.com"
        href="https://www.facebook.com/kieduser"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-blue-600 transition-colors"
      >
        <FacebookIcon />
      </a>
      <a
        // href="https://linkedin.com"
        href="https://www.linkedin.com/in/kiedkerala"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-sky-700 transition-colors"
      >
        <LinkedInIcon />
      </a>
    </div>
  )
}

export default MediaSwitcher
